import { environment } from "./../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { shareReplay, catchError } from "rxjs/operators";
import { EMPTY, Observable } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { MessageToastService } from "../common/message-toast.service";
import {
  GeoFilterResource,
  GeoItemCountQueryResult,
  GeoItemCountResource,
  GeoItemQueryResult,
  GeoItemReplace,
  GeoItemReplaceForm,
  GeoItemResource,
  IGeo,
} from "src/app/models/igeo.interface";
import { IPerson } from "src/app/models/iperson.interface";
import { HTTP_CONTENT_HEADERS } from "src/app/shared/data/const.data";
import { KeyValue } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class GeocodeService {
  private geocodeApi = environment.geocodeApi;

  private url = "geo";
  private api = environment.apiUrl;

  constructor(private http: HttpClient, private msg: MessageToastService) {}

  search(str: string): Observable<IGeo[]> {
    const headers = new HttpHeaders();
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append(
      "Access-Control-Allow-Methods",
      "GET, POST, OPTIONS, PUT, PATCH, DELETE"
    );
    headers.append(
      "Access-Control-Allow-Headers",
      "X-Requested-With,content-type"
    );

    return this.http
      .get<IGeo[]>(
        `${this.geocodeApi}?format=json&addressdetails=1&q=${str}&format=json&limit=3`,
        { headers: headers }
      )
      .pipe(
        catchError((err) => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  getCities(filter: string = ''): Observable<GeoItemResource[]> {
    const params = new HttpParams().set('filter', filter);
    return this.http
      .get<GeoItemResource[]>(`${this.api}${this.url}/list/cities`, {params})
      .pipe(
        catchError((err) => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  table(filter: string): Observable<GeoItemQueryResult> {
    return this.http
      .get<GeoItemQueryResult>(`${this.api}${this.url}/table/?${filter}`)
      .pipe(
        catchError((err) => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  tableCounts(filter: string): Observable<GeoItemCountQueryResult> {
    return this.http
      .get<GeoItemCountQueryResult>(`${this.api}${this.url}/counts/?${filter}`)
      .pipe(
        catchError((err) => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  updateGeo(form: GeoItemReplaceForm) {
    return this.http.post(`${this.api}${this.url}/replace`, form).pipe(
      // catchError(err => {
      //   this.msg.errorEx(err);
      //   return EMPTY;
      // }),
      shareReplay()
    );
  }

  delete(ids: number[]) {
    return this.http.post(`${this.api}${this.url}/delete`, ids).pipe(
      catchError((err) => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  searchLocal(str: string): Observable<GeoItemResource[]> {
    return this.http
      .get<GeoItemResource[]>(`${this.api}${this.url}/search?str=${str}`)
      .pipe(
        catchError((err) => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  tableFilter(): Observable<GeoFilterResource> {
    return this.http
      .get<GeoFilterResource>(`${this.api}${this.url}/table/filter`)
      .pipe(
        catchError((err) => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  clearCache() {
    return this.http
      .get<GeoItemResource[]>(`${this.api}${this.url}/cache/reset`)
      .pipe(
        catchError((err) => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  getPersonForCity(cityIds: number[]) {
    return this.http
      .post<IPerson[]>(`${this.api}${this.url}/city/persons`, cityIds)
      .pipe(
        catchError((err) => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  getPersonForRegion(regions: GeoItemCountResource[]) {
    return this.http
      .post<IPerson[]>(`${this.api}${this.url}/region/persons`, regions)
      .pipe(
        catchError((err) => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  export() {
    const url = `${this.api}${this.url}/table/export`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set("Accept", HTTP_CONTENT_HEADERS.Excel);

    return this.http
      .get(url, {
        observe: "response",
        headers: hdrs,
        responseType: "blob",
      })
      .pipe(
        catchError((err) => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }
}
